import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Image, Text } from "@chakra-ui/react";
import { IMG_URL } from "../common/Constant";
const ICONS = {
    mute: `${IMG_URL}/icons/mute.svg`,
    unmute: `${IMG_URL}/icons/unmute.svg`,
};
export const AudioStatusButton = ({ type, onClick }) => {
    return (_jsxs(Box, { onClick: onClick, cursor: "pointer", position: "absolute", bottom: "20px", right: "20px", zIndex: 100, w: { base: "60px" }, h: { base: "60px" }, bg: "rgba(0,0,0,0.6)", borderRadius: "full", display: "flex", flexDir: "column", alignItems: "center", justifyContent: "center", _hover: { bg: "rgba(0,0,0,0.8)" }, transition: "0.2s", gap: { base: "4px" }, children: [_jsx(Image, { src: ICONS[type], alt: type, boxSize: { base: "20px" } }), _jsx(Text, { fontSize: { base: "10px" }, fontWeight: "500", color: "white", textTransform: "capitalize", children: type })] }));
};
